import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import TwoOptionToggle from '../TwoOptionToggle'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
}

/**
 * Connects a TwoOptionToggle (switch) component with Formik
 */
function FormikTwoOptionToggle(props) {
  const { id, onChange = null } = props ?? {}

  return (
    <Field name={id}>
      {({ field, form }) => (
        <TwoOptionToggle
          {...props}
          checked={field.value === true}
          onChange={(value) => {
            form.setFieldValue(id, value)
            if (onChange) {
              onChange(value)
            }
          }}
        />
      )}
    </Field>
  )
}

FormikTwoOptionToggle.propTypes = propTypes

export default FormikTwoOptionToggle
